module.exports = __webpack_public_path__ + "static/media/(H)_MG_5766_-_bijuterias.2a2c0dc1.jpg";